<template>
  <div class="authResultBody">
    <Header />
    <div class="authResultMain">
      <Step :num='3' />
      <div v-if="!msg" class="authenticationResult">
        <img src="@/assets/image/success.png">
        <h2>认证通过</h2>
        <h5>恭喜您，已通过个人实名认证，完成授权</h5>
        <el-button v-if="isCert" disabled type="primary" size="small">完成（{{ time }}s）</el-button>
        <el-button v-if="!isCert" type="primary" size="small">完成认证</el-button>
      </div>
      <div v-if="msg" class="authenticationResult">
        <img src="@/assets/image/fail.png">
        <h2>认证不通过</h2>
        <dl>
          <dt>不通过原因：</dt>
          <dd>{{ msg }}</dd>
        </dl>
        <el-button type="primary" size="small">重新认证</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: sessionStorage.getItem('verifyMsg'),
      time: 3,
      intervals: [],
      isCert:this.$store.state.userInfo.isCert,
    }
  },
  mounted() {
    if (this.isCert) {
      this.intervals.push(
      setInterval(() => {
        this.time--
        if(this.time == 0) {
          this.clearInterval()
        }
      },1000)
    )
    }
    
  },
  methods: {
    clearInterval() {
      for (let i of this.intervals) {
        clearInterval(i)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.authResultBody {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  background: #f1f3f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.authResultMain {
  width: 1600px;
  flex: 1;
  min-height: 650px;
  margin: 16px auto 0;
  background: #fff;
  padding: 0px 0 40px;
}
.authenticationResult {
  width: max-content;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 120px;
    margin-top: 52px;
  }
  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 27px;
    letter-spacing: 1px;
    margin-top: 18px;
  }
  h5 {
    margin: 8px 0 32px;
    font-size: 14px;
    color: #929292;
    line-height: 22px;
    font-weight: normal;
  }
  dl {
    width: 450px;
    background: #f1f5ff;
    border-radius: 4px;
    padding: 16px;
    margin: 32px 0;
  }
  dt {
    padding-left: 24px;
    background: url('~@/assets/image/warning.png') no-repeat;
    background-size: 16px;
    font-size: 14px;
    color: #333333;
    line-height: 19px;
    font-weight: bold;
  }
  dd {
    margin-top: 12px;
    font-size: 14px;
    color: #595959;
    line-height: 16px;
  }
  .is-disabled{
    background-color: #1c67f3;
    background-color: var(--main-bg-color);
    border-color: #1c67f3;
    border-color: var(--main-bg-color);
    opacity: 0.4;
    border-radius: 4px;
  }
}
</style>